import { render } from "./TransactionList.vue?vue&type=template&id=5839301d&scoped=true"
import script from "./TransactionList.vue?vue&type=script&lang=js"
export * from "./TransactionList.vue?vue&type=script&lang=js"

import "./TransactionList.vue?vue&type=style&index=0&id=5839301d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5839301d"]])

export default __exports__